import { Injectable, signal } from '@angular/core';

export interface ConfirmRequest {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  danger: boolean;
  resolve: (v: boolean) => void;
}

export interface ConfirmOptions {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean; // red confirm button for destructive actions
}

/**
 * In-app confirmation dialog (replaces the native window.confirm). `confirm()` returns a Promise
 * that resolves true/false when the user clicks Confirm/Cancel. Rendered by <app-confirm-dialog>.
 */
@Injectable({ providedIn: 'root' })
export class ConfirmService {
  readonly current = signal<ConfirmRequest | null>(null);

  confirm(opts: ConfirmOptions): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.current.set({
        title: opts.title ?? 'Are you sure?',
        message: opts.message,
        confirmText: opts.confirmText ?? 'Confirm',
        cancelText: opts.cancelText ?? 'Cancel',
        danger: opts.danger ?? false,
        resolve,
      });
    });
  }

  private settle(value: boolean) {
    const req = this.current();
    if (!req) return;
    this.current.set(null);
    req.resolve(value);
  }
  accept() { this.settle(true); }
  cancel() { this.settle(false); }
}
